

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { User } from './user';
import { UserService } from './user.service';
import { Role } from './role';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    templateUrl: 'user-create.component.html'
})
export class UserCreateComponent implements OnInit {
    @Input() user: User;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    roles: Role[];
    selectedRole: Role;
    storedRoles: Role[];
    storedStatus: number;
    isFirst: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;

    constructor(
        private toasterService: ToasterService,
        private router: Router,
        private _service: NotificationsService,
        private userService: UserService,
        private route: ActivatedRoute) {
    }
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    getRoles() {
        return this.userService
            .getRoles()
            .then(res => {
                this.roles = res.user_roles;
                this.checkRole(this.roles.find(r => r.role_name == 'User'));
                this.roles = this.roles.filter(r => r.role_name != 'User');
            })
            .catch(error => this.errorHandler(error));
    }


    ngOnInit() {
        this.user = new User();
        this.getRoles();
        this.storedStatus = 1;
        this.storedRoles = [new Role(null)];
        this.isFirst = true;

    }
    save1(user: User, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            this.submitting = true;
            user.user_roles = this.storedRoles;
            user.status = this.storedStatus;
            this.save(user);
        }
    }

    checkRole(role: Role) {
        if (this.isFirst == true) {
            this.storedRoles.splice(0, 1);
            this.isFirst = false;
            this.storedRoles.push(role);
        }

        else {
            if (this.storedRoles.indexOf(role, 0) > -1) {
                this.storedRoles.splice(this.storedRoles.indexOf(role), 1);
            } else {
                this.storedRoles.push(role);
            }
        }
    }

    checkStatus() {
        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }

    deleteRole(role: Role) {
        this.roles.push(role);
        this.user.user_roles.splice(this.user.user_roles.indexOf(role), 1);
    }
    save(user: User) {
        this.user = user;
        this.userService
            .createUser(this.user)
            .then(user => {
                this.user = user; // saved hero, w/ id if new
                this.goBack(user);
            })
            .catch(error => this.errorHandler(error));
    }
    goBack(savedUser: User = null) {
        this.close.emit(savedUser);
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/parrot']);
        }
    }


    public activeStatus = [
        { value: 0, display: 'Inactive' },
        { value: 1, display: 'Active' },
    ];

    selectRole(role: Role) {
        this.selectedRole = role;
    }
}



// WEBPACK FOOTER //
// ./src/app/user/user-create.component.ts